import { mapShapecodeToName } from "areas/product/store/helpers/diamond"

const displayOptionDescription = (
  wizardData,
  pref,
  choices,
  diamondSelector,
  diamondUI
) => {
  const choiceData = choices[pref]
  if (!wizardData) {
    return null
  }

  if (wizardData && wizardData.description) {
    return wizardData.description
  }
  if (wizardData.pref == "ef" || wizardData.pref == "ef2") {
    let desc = ""
    let sortedChoices = Object.keys(choices).sort()
    sortedChoices.forEach((key) => {
      if (
        key[0] == "e" &&
        key != "ef" &&
        key != "ef2" &&
        key != "ec" &&
        !choices[key].disabled &&
        !choices[key].is_default &&
        choices[key].value &&
        choices[key].value != "" &&
        !choices[key].settings_metal
      ) {
        if (choices[key]?.engraving_font !== wizardData.pref) return
        if (desc == "") {
          desc = choices[key].value
        } else {
          desc += ", " + choices[key].value
        }
      }
    })
    // if (desc === "") {
    //   desc = "Choose your engravings" //Default text for ring engravings
    // }
    return desc
  } else if (wizardData.pref == "sku") {
    let desc = ""
    if (choices.sku && choices.sku.full_title) {
      desc = choices.sku.full_title
    }
    return desc
  } else if (wizardData.pref == "sz") {
    //Default text for  ring or pendant size
    let desc = ""
    if (wizardData.not_a_ring) {
      //desc = "Choose your pendant size"
    } else {
      //desc = "Choose your ring size"
    }
    if (choices.sz && choices.sz.value) {
      desc = choices.sz.title
    }
    return desc
  } else if (wizardData.pref == "ch" || /ch[0-9]+$/.test(wizardData.pref)) {
    let desc = "" // "Choose your chain length" //Default text for chain length
    if (choiceData && choiceData.chain_length) {
      desc = choiceData.title
    }
    return desc
  } else if (wizardData.pref == "a1" || wizardData.pref == "a2") {
    let desc = "" //"Choose your charm (optional)" //Default text for charm option
    if (
      choices[wizardData.pref] &&
      choices[wizardData.pref].code &&
      !choices[wizardData.pref].disabled
    ) {
      desc = choices[wizardData.pref].title
      if (wizardData.heading.description) desc += wizardData.heading.description
    }
    return desc
  } else if (wizardData.pref === "sc") {
    let desc = ""
    if (choiceData && choiceData.title) {
      desc = `${choiceData.title} ${choiceData.stone_count > 1 ? "Stones" : "Stone"}`
    }
    return desc
  } else if (
    choiceData &&
    wizardData.options_display_labels &&
    Object.keys(wizardData.options_display_labels).length > 1
  ) {
    let desc = []
    const optionsDisplayLabels = wizardData.options_display_labels
    Object.keys(optionsDisplayLabels).forEach((pref) => {
      if (choices[pref] && choices[pref].title) {
        desc.push(`${optionsDisplayLabels[pref]}: ${choices[pref].title}`)
      }
    })
    return desc.join(", ")
  } else if (wizardData.settings_metal) {
    let desc = ""
    if (typeof choiceData !== "undefined") {
      desc = choiceData.title
    }
    if (diamondSelector.signatureBasket) {
      if (typeof choices.e1 !== "undefined") {
        desc += (desc == "" ? "" : ", ") + "Side 1 Initial: " + choices.e1.value
      }
      if (typeof choices.e2 !== "undefined") {
        desc += (desc == "" ? "" : ", ") + "Side 2 Initial: " + choices.e2.value
      }
    }
    return desc
  } else if (pref == "diamond") {
    let desc = ""
    const diamond = diamondSelector.selected_diamond
    const showDesc =
      diamondUI.steps[diamondUI.currentStep] == "final_diamond" && diamond
    if (showDesc) {
      const stoneType = diamondSelector.d_stone_type?.find(
        (s) => s.value === diamond.stone_type
      )
      if (stoneType) {
        desc = `${stoneType.title}, `
      }

      if (diamond?.shape && diamond.carat) {
        desc += `${mapShapecodeToName[diamond.shape]}, ${
          diamond.is_diamond ? `${diamond.carat}ct` : diamond.stone_size
        }`
      }
    }
    return desc
  } else {
    if (typeof choiceData === "undefined") {
      return ""
    } else {
      return choiceData.title
    }
  }
}

export default displayOptionDescription
